// Shared formatting helpers for the inventory module.

export function fmtMoney(n) {
  const v = Number(n || 0);
  return v.toLocaleString('en-US', {
    style: 'currency', currency: 'USD',
    minimumFractionDigits: 0, maximumFractionDigits: 0,
  });
}

export function fmtNumber(n) {
  return Number(n || 0).toLocaleString('en-US');
}

export function fmtDate(d) {
  if (!d) return '—';
  const s = String(d).slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return `${+m[2]}/${+m[3]}/${m[1]}`;
  return s;
}

// Aisle-Row-Bin as one location string. Blank segments are dropped rather than
// rendered as gaps, so a part shelved with no aisle reads "B-2" instead of
// "-B-2", which looks like a truncated value.
export function fmtBin(item) {
  if (!item) return '—';
  const parts = [item.aisle, item.row_name, item.bin]
    .map((p) => (p === null || p === undefined ? '' : String(p).trim()))
    .filter(Boolean);
  return parts.length ? parts.join('-') : '—';
}

export function fmtMonth(d) {
  if (!d) return '—';
  const s = String(d).slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-\d{2}$/);
  if (!m) return s;
  // The date is built in UTC, so it must be formatted in UTC too. Without the
  // explicit zone this formats in the BROWSER's zone: for anyone west of
  // Greenwich — which is every user, all of them in California — UTC midnight
  // on the 1st is the previous evening, and an August snapshot renders "Jul".
  // Wrong by a whole month, on a label nobody would think to double-check.
  return new Date(Date.UTC(+m[1], +m[2] - 1, 1))
    .toLocaleDateString('en-US', { month: 'short', year: 'numeric', timeZone: 'UTC' });
}
